export default __webpack_public_path__ + "static/media/queenlila7.295b855b.jpg";